import type { CheckoutSessionCommunity } from "@circle-react/types/Paywalls/Checkout/Session";

interface ContentProps {
  community: Pick<CheckoutSessionCommunity, "name" | "icon_url" | "logo_url">;
}

export const Content = ({ community }: ContentProps) => {
  if (community?.logo_url) {
    return (
      <img
        loading="eager"
        className="max-h-12 max-w-48 object-contain"
        src={community.logo_url}
        alt=""
      />
    );
  }

  if (community?.icon_url) {
    return (
      <div className="flex flex-row gap-x-2 items-center">
        <img
          loading="eager"
          className="max-h-9 max-w-9 object-contain"
          src={community.icon_url}
          alt=""
        />
        <span className="text-lg font-medium">{community.name}</span>
      </div>
    );
  }

  return <span className="text-lg font-medium">{community?.name}</span>;
};
